/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMailingListDto as FeatureMailingListsCreateMailingListDto } from '../../models/feature/mailing-lists/create-mailing-list-dto';
import { MailingListDto as FeatureMailingListsMailingListDto } from '../../models/feature/mailing-lists/mailing-list-dto';

export interface CreateMailingList$Params {
      body: FeatureMailingListsCreateMailingListDto
}

export function createMailingList(http: HttpClient, rootUrl: string, params: CreateMailingList$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureMailingListsMailingListDto>> {
  const rb = new RequestBuilder(rootUrl, createMailingList.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FeatureMailingListsMailingListDto>;
    })
  );
}

createMailingList.PATH = '/create-mailing-list-dialog';

